export const mapFileUrl = data => `${data.url}/${data.fields.key}`;
